import { Link, useLocation } from "react-router-dom";
import { ReactComponent as HomeIcon } from "../../assets/modal-home.svg";
import { ReactComponent as LearningsIcon } from "../../assets/modal-coaches.svg";
import { ReactComponent as BookmarksIcon } from "../../assets/modal-journal.svg";
import { ReactComponent as CommunityIcon } from "../../assets/modal-community.svg";
import { ReactComponent as ProfileIcon } from "../../assets/modal-profile.svg";
import { ReactComponent as CloseIcon } from "../../assets/modal-close.svg";
import { ReactComponent as JobsIcon } from "../../assets/jobs.svg";
import { ReactComponent as CalendarIcon } from "../../assets/appointment.svg";

import { useContext, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { GetAuthorizedRoutes } from "../../hooks/useAuthorizedRoutes";
import { routes } from "../../routes";
import { IRoute } from "../../@types";
import FAQHandler from "../FAQ";
import { TeaserDetails } from "../teaser";
import { useTranslation } from "react-i18next";
import { QuickLinks } from "../quickLinks";

export function ModalNavigation({
  isModalOpen,
  onClose,
}: {
  isModalOpen: boolean;
  onClose: () => void;
}) {
  const location = useLocation();
  const pathName = location.pathname.split("/")[1] || "home";
  const { configurations } = useContext(AuthContext);

  const authorizedRoutes = GetAuthorizedRoutes(configurations, routes)?.filter(
    (route: any) => !route?.hidden
  );
  const { t } = useTranslation("navbar");

  const renderIcon = (pathname: string) => {
    console.log(pathName);
    switch (pathname) {
      case "home":
        return { icon: <HomeIcon /> };
      case "coaches":
        return { icon: <LearningsIcon /> };
      case "community":
        return { icon: <CommunityIcon /> };
      case "journal":
        return { icon: <BookmarksIcon /> };
      // 12px top and bottom, 8px left and right
      case "jobs":
        return { icon: <JobsIcon /> };
      case "profile":
        return { icon: <ProfileIcon /> };
      case "appointments":
        return { icon: <CalendarIcon /> };
      default:
        return { icon: null };
    }
  };

  const faqIndex = Math.max(
    authorizedRoutes?.findIndex(
      (route: any) => route?.nameCode?.toLowerCase() === "coaches"
    ) + 1,
    authorizedRoutes?.findIndex(
      (route: any) => route?.nameCode?.toLowerCase() === "community"
    ),
    1 // Default to second position if other conditions fail
  );

  const modifiedRoutes = [...authorizedRoutes];
  if (faqIndex >= 0 && configurations?.includesFAQ) {
    modifiedRoutes?.splice(faqIndex, 0, {
      nameCode: "FAQ",
      path: "#", // FAQ doesn't have a traditional route, it triggers an action
    });
  }

  if (!isModalOpen) return null; // Render nothing if the modal is not open

  return (
    <div className="lg:hidden fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="w-full h-full bg-[#F3F5F7] relative overflow-y-auto">
        {/* X button to close the modal */}
        <div
          className="flex justify-end items-center"
          style={{ height: "64px", padding: "18px" }}
        >
          <button
            className="cursor-pointer"
            onClick={onClose} // Close the modal
          >
            <CloseIcon />
          </button>
        </div>

        {/* Flex container with padding to account for left and right margins */}
        <div className="flex flex-wrap justify-start items-start gap-3 px-6">
          {/* Added px-6 for 24px left and right padding */}
          {modifiedRoutes
            .filter((r: IRoute) => !r?.hidden)
            .map((r: IRoute) => (
              <div
                key={r?.nameCode}
                className="flex flex-col items-center justify-center w-[calc(33.333%_-_8px)] h-[120px] p-4 bg-[#FFDA6F] rounded-lg gap-2 "
              >
                {r?.nameCode === "FAQ" ? (
                  <FAQHandler isMobile={true} onClose={onClose} />
                ) : (
                  <Link to={r?.path} onClick={onClose}>
                    {/* Close modal on click */}
                    <div className="flex flex-col items-center justify-center h-full">
                      {/* Flex column to center */}
                      <div className="flex items-center justify-center mb-2">
                        {/* Icon wrapper */}
                        {renderIcon(r?.nameCode)?.icon}
                      </div>
                      <p
                        className="text-center text-base font-[700]"
                        style={{ lineHeight: "1rem" }}
                      >
                        {t(`${r?.nameCode}`)}
                      </p>
                      {/* Text below the icon */}
                    </div>
                  </Link>
                )}
              </div>
            ))}

          {/* Create empty divs for spacing when fewer than 3 items */}
          {modifiedRoutes.length < 3 &&
            Array.from({ length: 3 - modifiedRoutes.length }).map(
              (_, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center w-[calc(33.333%_-_8px)] h-[120px] p-4 bg-transparent rounded-lg flex-shrink-0" // Empty div for spacing
                />
              )
            )}
        </div>

        <div className="my-12 mx-6 ">
          <div style={{ background: "#A7B6C5", height: "1px" }} />
        </div>
        <div className="my-12 px-6">
          <TeaserDetails onClose={isModalOpen ? onClose : undefined} />
        </div>
        {/* <div className="my-12 mx-6 ">
          <div style={{ background: "#A7B6C5", height: "1px" }} />
        </div> */}
        <div className="my-12 px-6">
          <QuickLinks onClose={isModalOpen ? onClose : undefined} />
        </div>
      </div>
    </div>
  );
}
